import { AxiosResponse } from "axios";
import { axiosInstance, MessageResponse } from "./common";

export interface CreditAccountRecoveryDetails {
  account_number: string;
  as_of_date?: string | null;
  total_recovery_amount?: number | null;
  post_npa_recovery_amount?: number | null;
  extent_of_loss_to_bank?: number | null;
}

export interface GetCreditAccountRecoveryResponse {
  recovery_details: CreditAccountRecoveryDetails[];
}

export interface UpsertCreditAccountRecoveryRequest {
  as_of_date: string;
  total_recovery_amount?: number | null;
  post_npa_recovery_amount?: number | null;
  extent_of_loss_to_bank?: number | null;
}

export const CreditAccountRecoveryAPI = {
  getFromET: async (account_numbers: string[]) => {
    const response: AxiosResponse<GetCreditAccountRecoveryResponse> =
      await axiosInstance.get(
        "/v1/et/credit-account-recovery",
        {
          params: {
            account_numbers,
          },
        }
      );

    return response.data;
  },

  upsert: async (
    case_id: string,
    account_number: string,
    request: UpsertCreditAccountRecoveryRequest
  ) => {
    const response: AxiosResponse<MessageResponse> =
      await axiosInstance.put(
        `/v1/cases/${case_id}/credit-accounts/${account_number}/credit-account-recovery`,
        request
      );

    return response.data;
  },
};